// extracted by mini-css-extract-plugin
export default {"Post":"styles_Post__7UkH4","collapsed":"styles_collapsed__GV7E9","title":"styles_title__8uUzD","commentsContainer":"styles_commentsContainer__5XIMR"};